<template>
  <div class="companies-list">
    <div class="text-group" v-if="$route.name === 'contacts'">
      <h3 class="text-accent">{{ $t("contacts-1") }}</h3>
      <h1>{{ $t("contacts-2") }}</h1>
    </div>
    <div class="text-group" v-else-if="$route.name !== 'news'">
      <h3 class="text-accent">{{ $t("companies-list-1") }}</h3>
      <h1>{{ $t("companies-list-2") }}</h1>
    </div>
    <div class="companies-list-wrapper">
      <template v-if="files">
        <section
          v-for="(file, index) of getList"
          class="companies-list-item news"
          :key="`${index}-${file.name}`"
          @click="file.file ? (isMediaModalOpen = file.file) : null"
        >
          <img :src="file.img" alt="" />
          <h2 class="medium text-light">{{ file.name }}</h2>
          <p class="text-light">{{ file.desc }}</p>
        </section>
      </template>
      <template v-else>
        <router-link
          v-for="(link, index) of getList"
          class="companies-list-item"
          :key="`${index}-${link.name}`"
          :to="link.to"
          :style="{ '--bg-img': `url(${link.img})` }"
        >
          <h2 class="medium text-light">{{ link.name }}</h2>
          <p class="text-light">{{ link.desc }}</p>
        </router-link>
      </template>
    </div>

    <transition name="fade">
      <MediaModal
        v-if="isMediaModalOpen"
        :media="isMediaModalOpen"
        @close-media-modal="isMediaModalOpen = undefined"
      />
    </transition>
  </div>
</template>

<script>
import MediaModal from "../shared/MediaModal.vue";
export default {
  components: { MediaModal },
  computed: {
    getList() {
      let list = [];

      if (this.files) {
        list = this.files;
      } else {
        for (let index = 0; index < 12; index++) {
          list.push({
            to: `/kcm-group?page=companies&c=${index + 1}&${
              this.$route.name === "contacts" ? "contacts=true" : ""
            }`,
            img: require(`@/assets/img/news/kcm-today/${index + 1}.jpg`),
            name: this.$t(`companies-list-${index * 2 + 3}`),
            desc: this.$t(`companies-list-${index * 2 + 4}`),
          });
        }
      }
      return list;
    },
  },
  props: ["files"],
  data() {
    return {
      isMediaModalOpen: undefined,
    };
  },
};
</script>

<style lang="scss" scoped>
.companies-list {
  padding: 0 $sidesPadding;
  .companies-list-wrapper {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 25px 0;
    .companies-list-item {
      background-color: $mainColor;
      cursor: pointer;
      margin-bottom: 20px;
      margin-right: 20px;
      padding: 20px;
      position: relative;
      @include transition(all 0.6s $mainCubic);
      width: calc(25% - 15px);

      &.news {
        background: initial;
        position: relative;
        overflow: hidden; 

        &::before {
          background: #0083c8;
          content: "";
          position: absolute;
          height: 100%;
          left: 50%;
          opacity: 1;
          top: 50%;
          transform: translate(-50%, -50%) scale(0);
          transform-origin: center;
          width: 50%;
          z-index: -1;
          @include transition(all 0.4s $mainCubic);
        }

        &:hover {
          &:before {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
          }
          .text-light {
            color: #ffffff;
          }
        }
        img {
          width: 100%;
        }
        .text-light {
          @include transition(all 0.5s $mainCubic);
          color: #064491;
        }
      }

      h2,
      p {
        position: relative;
        text-align: center;
        z-index: 1;
      }
      h2 {
        font-size: 18px;
        margin-bottom: 20px;
      }
    }
    .companies-list-item:nth-child(4n) {
      margin-right: 0;
    }
    .companies-list-item::before {
      background-image: var(--bg-img);
      background-size: cover;
      background-position: center;
      content: "";
      height: 100%;
      left: 0;
      opacity: 0;
      position: absolute;
      top: 0;
      @include transition(all 0.6s $mainCubic);
      width: 100%;
    }
    .companies-list-item:hover {
      @include transform(scale(1.1));
      p {
        opacity: 1;
      }
    }
    .companies-list-item:hover::before {
      opacity: 0.5;
    }
  }
}
@media screen and (max-width: 1600px) {
  .companies-list {
    padding: 0 $sidesPadding1600;
  }
}
@media screen and (max-width: 1376px) {
  .companies-list {
    .companies-list-wrapper {
      .companies-list-item {
        h2 {
          font-size: 15px;
          margin-bottom: 18px;
        }
        p {
          font-size: 11px;
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .companies-list {
    padding: 0 $sidesPadding1280;
    .companies-list-wrapper {
      .companies-list-item {
        h2 {
          font-size: 14px;
          margin-bottom: 17px;
        }
        p {
          font-size: 10px;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .companies-list {
    .companies-list-wrapper {
      .companies-list-item {
        width: calc(33.33% - 13.33px);
      }
      .companies-list-item:nth-child(1n) {
        margin: 0 20px 20px 0;
      }
      .companies-list-item:nth-child(3n) {
        margin: 0 0 20px 0;
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .companies-list {
    .companies-list-wrapper {
      .companies-list-item {
        width: calc(50% - 10px);
      }
      .companies-list-item:nth-child(1n) {
        margin: 0 20px 20px 0;
      }
      .companies-list-item:nth-child(2n) {
        margin: 0 0 20px 0;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .companies-list {
    padding: 0 $sidesPadding600;
    .companies-list-wrapper {
      .companies-list-item {
        width: 100%;
      }
      .companies-list-item:nth-child(1n) {
        margin: 0 0 20px 0;
      }
    }
  }
}
</style>
